<template>
  <div class="question-steam">
    <p
      v-if="exercise.title"
      v-html="exercise.title"
      class="title">
    </p>
    <div
      v-if="exercise.image"
      @click="preview"
      class="image-wrapper">
      <img
        :src="exercise.image"
        ondragstart="return false"
        alt="">
        <i
          title="放大"
          class="el-icon-zoom-in"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    exercise: {
      type: Object,
      required: true,
    },
  },
  methods: {
    preview() {
      // this.$emit('preview');
      const wrap = document.createElement('div');
      wrap.style.position = 'fixed';
      wrap.style.left = '0';
      wrap.style.right = '0';
      wrap.style.top = '0';
      wrap.style.bottom = '0';
      wrap.style.background = 'rgba(0, 0, 0, .8)';
      wrap.style.zIndex = '999999';
      wrap.style.overflow = 'auto';
      wrap.onclick = () => {
        document.body.removeChild(wrap);
      };
      const img = document.createElement('img');
      img.src = this.exercise.image;
      img.style.display = 'block';
      img.style.margin = '20px auto';
      img.style.maxHeight = '90%';
      img.style.maxWidth = '90%';

      const close = document.createElement('img');
      close.src = 'https://img1.wxzxzj.com/vuedece1350d37e73d157c24d20839e57aaf.png';
      close.style.width = '36px';
      close.style.height = '36px';
      close.style.position = 'fixed';
      close.style.right = '20px';
      close.style.top = '20px';
      close.style.cursor = 'pointer';

      wrap.appendChild(img);
      wrap.appendChild(close);
      document.body.appendChild(wrap);
    },
  },
};
</script>

<style lang="scss" scoped>
 @import '@/styles/variables.scss';
  .question-steam {
    // min-height: 230px;
    margin-top: 20px;
    position: relative;
    .title {
      margin-left: 25px;
      font-size: 18px;
      line-height: 30px;
    }
    .image-wrapper {
      text-align: center;
      cursor: pointer;
      img {
        max-width: 94%;
        max-height: 280px;
      }
    }
    .el-icon-zoom-in {
      font-size: 30px;
      &:hover {
        color: $primary;
      }
    }
  }
</style>
